var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "header",
      { staticClass: "header" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "新问答汇总", name: "1" } },
              [_c("allQuestions", { attrs: { selsect: "全部", state: "1" } })],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "我回答的", name: "2" } },
              [
                _c("allQuestions", {
                  attrs: { selsect: "全部已回答", state: "2" },
                }),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "我提问的", name: "3" } },
              [
                _c("allQuestions", {
                  attrs: { selsect: "全部我的提问", state: "3" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }